// @flow
import React from 'react';

import {
  Confirmation,
  type Props as ConfirmationProps,
} from 'Components/widgets/confirmation/Confirmation.jsx';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer.jsx';

type Props = {
  ...$Exact<ConfirmationProps>,
  hasShadow: boolean,
  id?: string,
};

export function SubmissionStatusLine({ id, hasShadow, ...props }: Props) {
  return (
    <SiteContainer
      id={id}
      hasBorders={hasShadow}
      hasShadowOutset={hasShadow}
      size="small"
      className="Line Line-SubmissionStatus"
    >
      <Confirmation {...props} />
    </SiteContainer>
  );
}
